/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section5_TitleInputs */

const en_terms_section5_title = /** @type {(inputs: Terms_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intellectual Property`)
};

const ko_terms_section5_title = /** @type {(inputs: Terms_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지적 재산권`)
};

const ja_terms_section5_title = /** @type {(inputs: Terms_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知的財産権`)
};

/**
* | output |
* | --- |
* | "Intellectual Property" |
*
* @param {Terms_Section5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section5_title = /** @type {((inputs?: Terms_Section5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section5_title(inputs)
	if (locale === "ko") return ko_terms_section5_title(inputs)
	return ja_terms_section5_title(inputs)
});